import Blue from "~/core";

new Blue({
	name: 'Content Share - Print',
	selector: ".content-sharing-button-bar a.content-sharing-button.button--print[data-print-path]",
	setup(printBtn) {
		const printPath = !!printBtn.getAttribute("data-print-path") ? printBtn.getAttribute("data-print-path") : window.location.origin + window.location.pathname + "?print=true";
		let iframe;
		
		const createSelfPrintingIframe = () => {
			iframe = document.createElement("iframe");
			iframe.classList.add("hidden-print-iframe");
			iframe.setAttribute("src", printPath);
			document.body.insertAdjacentElement("beforeend", iframe);
			iframe.onload = () => iframe.contentWindow.print();
			iframe.contentWindow.onafterprint = () => iframe.remove();
		}

		this.$addEvents(printBtn, "click.prevent", () => {
			if (printPath) createSelfPrintingIframe();
			else window.print();
		});

		// BELOW CODE IS FOR HIDING MAIN PAGE CONTENT AND SHOWING PRINT-SPECIFIC LAYOUT ON PRINT
		// NOT USING IT YET BECAUSE I WILL NEED MORE TIME TO GET BE MARKUP ALIGNED FOR THIS STRATEGY
		// window.addEventListener("beforeprint", (e) => {
		// 	const hidden = document.querySelector("#print-page-hide");
		// 	if (!!hidden) hidden.classList.add("showing")
		// });
		// window.addEventListener("afterprint", (e) => {
		// 	const hidden = document.querySelector("#print-page-hide");
		// 	if (!!hidden) hidden.classList.remove("showing")
		// });
	}
});